import { Controller } from "@hotwired/stimulus"

// Toggles the activity checkboxes visibility when switching between
// "Alle activiteiten" and "Specifieke selectie" radio buttons.
export default class extends Controller {
  static targets = ["activities"]

  toggle(event) {
    if (event.target.value === "specific") {
      this.activitiesTarget.classList.remove("hidden")
    } else {
      this.activitiesTarget.classList.add("hidden")
    }
  }
}
